import { AddressViewModel } from '../ViewModels/AddressViewModel.csharp';

export const formatAddressToDisplay = (address: AddressViewModel | undefined, showPhoneNumber = true): string => {
    if (!address) return '';

    let addressText = address.firstName.trim();
    if (address.lastName) addressText += ` ${address.lastName.trim()}`;
    if (address.companyName) addressText += `, ${address.companyName.trim()}`;

    addressText += `, ${address.line1.trim()}`;
    addressText += `, ${address.postalCode.trim()} ${address.city.trim()}`;

    if (showPhoneNumber) addressText += `, ${address.phoneNumber.trim()}`;

    return addressText;
};
